import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./CompletionStackedBarChart.css"

const getSeriesData = (programs, completionData) => {
    let colors = ["#6AA4DC", "#FFB607"];
    const categories = programs;
    const series = [
        { name: 'Change 2021-2031', data: [], color: colors[1], borderColor: colors[1], },
        { name: '2021', data: [], color: colors[0], borderColor: colors[0], },
    ];

    categories.forEach(category => {
        const categoryData = completionData[category];
        series[1].data.push({ y: 0 });
        series[0].data.push({ y: 0 });
        categoryData.forEach(item => {
            const dataIndex = categories.indexOf(category);
            if (item.year === 2021) {
                series[1].data[dataIndex] = {
                    y: item.degrees || 0,
                    ...item
                };
            } else {
                series[0].data[dataIndex] = {
                    y: item.degrees || 0,
                    ...item
                };
            }
        });
    });

    return { series, categories };
};


class CompletionStackedBarChart extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { series, categories } = getSeriesData(this.props.programNames, this.props.completionData)

        const options = {
            chart: {
                animation: false,
                type: "bar",
                backgroundColor: "#0F3E6E",
                height: 710,
                width: 965,
                spacingTop: 0,
                marginRight: 40,
                dataLabels: false,
                scrollablePlotArea: {
                    minHeight: 300 + 50 * categories.length,
                    opacity: 1,
                },
            },
            plotOptions: {
                series: {
                    stacking: "normal",
                    animation: false,
                    groupPadding: 0.15,
                    pointPadding: 1,
                    pointWidth: 25,
                },
            },
            series: series,
            xAxis: {
                scrollbar: {
                    enabled: true,
                },
                categories: categories,
                title: {
                    text: null,
                },
                labels: {
                    useHTML: true,
                    formatter: function() {
                        const titleCaseLabel = this.value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');

                        return `<div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; width: 250px; color: #fff; font: normal normal normal 13px Arial; text-align: right;">
                                    ${titleCaseLabel}
                                </div>`;
                    }
                },
                align: 'right',
            },
            yAxis: {
                scrollbar: {
                    enabled: true,
                },
                offset: 10,
                title: {
                    text: "Number of Completions",
                    style: {
                        color: "#fff",
                        font: "normal normal normal 18px Arial",
                        letterSpacing: "0.49px",
                    },
                },
                labels: {
                    overflow: "justify",
                    style: {
                        color: "#fff",
                        font: "normal normal normal 18px Arial",
                    },
                    formatter: function() {
                        // Check if the absolute value is 1000 or more
                        if (Math.abs(this.value) >= 1000) {
                            // Divide the value by 1000 and append 'K', preserving the sign for negative values
                            return (this.value / 1000) + 'K';
                        } else {
                            // For values less than 1000, return the value directly
                            return this.value;
                        }
                    }
                },
                // tickInterval: countTickInterval,
                // min: minCountData,
                gridLineWidth: 0.5,
            },
            exporting: { enabled: false },
            title: null,
            legend: {
                reversed: true,
                itemStyle: {
                    color: "#FFF",
                    font: "normal normal normal 16px/27px Arial",
                },
                verticalAlign: "top",
                align: "left",
                x: 80,
                backgroundColor: "transparent",
                padding: 20,
                itemMarginTop: 5,
                itemMarginBottom: 10,
                symbolRadius: 0,
                symbolHeight: 15,
                symbolWidth: 15,
            },
            credits: {
                enabled: false
            },
            tooltip: {
                borderRadius: 15,
                borderWidth: 1,
                borderColor: "#707070",
                backgroundColor: "#FFFFFF",
                padding: 17,
                shape: "square",
                style: {
                    font: "Arial",
                    fontSize: "14px",
                    color: "#333333",
                    lineHeight: 25,
                    zIndex: 999,
                },
                formatter: function () {
                    const program = this.x;
                    let tooltip = `Program: <b>${program}</b><br/>${this.series.name} completions: <strong>${Highcharts.numberFormat(this.y, 0)}</strong><br/>`;
                    if (this.series.name === '2021') {
                        tooltip += `Certificates: <strong>${(this.point.certificates_percent || 0).toFixed(2)}%</strong><br/>`;
                        tooltip += `Associates: <strong>${(this.point.associates_degree_percent || 0).toFixed(2)}%</strong><br/>`;
                        tooltip += `Bachelors: <strong>${(this.point.bachelors_degree_percent || 0).toFixed(2)}%</strong><br/>`;
                        tooltip += `Masters: <strong>${(this.point.masters_degree_percent || 0).toFixed(2)}%</strong><br/>`;
                        tooltip += `Doctorates: <strong>${(this.point.doctors_degree_percent || 0).toFixed(2)}%</strong><br/>`;
                    }
                    return tooltip;
                }
            }
        };

        return (
            <div>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
        );
    }
}


export default CompletionStackedBarChart;
